import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wpcm-top-title"
}
const _hoisted_2 = {
  key: 1,
  class: "wpcm-popup-title"
}
const _hoisted_3 = {
  key: 2,
  class: "wpcm-popup-tagline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($props.top_title)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString($setup.props.top_title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($props.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString($setup.props.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($props.tagline)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.props.tagline), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}